import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';

const controlStyles = {
    borderRadius: '1px solid black',
    padding: '5px',
    color: 'white',
    width: '300px',
};

const ControlComponent = (props) => (
    <div style={controlStyles}>
        <components.Control {...props} />
    </div>
);

const InfoHubCategoryDropdown = ({ getCategoryID, categoryID, categoryName }) => {
    const [categories, setCategories] = useState([]);
    const [selectedOption, setSelectedOption] = useState( categoryID ? {
        value: categoryID,
        label: categoryName
    }: null);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        const getCategories = async () => {
            const categoryFromServer = await fetchCategories();
            setCategories(categoryFromServer);
        };

        getCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Fetch Categories
    const fetchCategories = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/infohub/getcategory'
        );
        const data = await res.json();

        return data.FileList;
    };

    const options = categories.map((category, index) => {
        return {
            value: category.categoryID,
            label: category.categoryName
        }
    })

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption);

        if (selectedOption) {
            getCategoryID(selectedOption.value)
        }
    };

    return (
        <Select
            placeholder={'Select a folder name...'}
            components={{ Control: ControlComponent }}
            value={selectedOption}
            onChange={handleChange}
            options={options}
            isClearable
        />
    );
};

export default InfoHubCategoryDropdown;
